export default __webpack_public_path__ + "static/guests-app-fff3b64c13bc8e5a77aadaa50ceae015.png";